import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'adf-help',
  standalone: true,
  imports: [CommonModule, NgbTooltip, TranslatePipe],
  templateUrl: './help.component.html',
})
export class HelpComponent {}
